// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useQuery } from '@tanstack/react-query';
import { getAuthenticationStrength } from '@api/portalServices';
import type { AuthenticationStrengthGetResponse } from '@api/types';
import type { ApiError } from '@errorHandler/errors';
import { QueryKey } from '@portal/constants';

/**
 * Custom hook to fetch authentication strength configuration for a given application
 * instance. Returns the tenant's current value plus the values entitled for selection.
 */
export const useAuthenticationStrengthQuery = (applicationId: string) => {
  return useQuery<AuthenticationStrengthGetResponse, ApiError>({
    queryKey: [QueryKey.AUTHENTICATION_STRENGTH, applicationId],
    queryFn: () => getAuthenticationStrength({ applicationId }),
    retry: false,
    staleTime: 0,
  });
};
